import React from 'react'
import { Section } from '@/components/shared/section/Section'
import { env } from '@/utils/constants/env'

export const ListPengajuanBeasiswa: React.FC = () => {
  return (
    <Section title="Dashboard Pengajuan Beasiswa">
      <div className="flex flex-col items-center gap-1 p-10">
        <iframe
          title="Pengajuan Beasiswa"
          src={env.iFrameMetabaseBeasiswa}
          frameBorder="0"
          width="100%"
          height="600"
        />
      </div>
    </Section>
  )
}
